import React from "react";
import majorScale from '../../../assets/images/piano_major_scale.gif';
import minorScale from '../../../assets/images/piano_minor_scale.gif';
import LinkService from "../../../services/LinkService";
//import minScale from '../../../piano_minor_scale.gif';

class PianoMajorMinorScales extends React.Component {
    constructor() {
        super();


    }

    render() {
        let linkService = new LinkService()

        return (
            <div>



                <h1>Major and Minor Scales</h1>
                See also:<br/>
                <ul>
                <li><b><a href={linkService.THEORY_PIANO_TRIADS}>Repeating Triad Chord Patterns in Major and Minor Scales</a></b>.</li>
                    <li><b><a  href={linkService.PIANO_TRIAD_REFERENCE}>Root Triads Chord Reference for all Major and Minor Scales on the Piano</a></b>.</li>
                </ul>
                For centuries, music theory in many countries
                around the world has focused on major and minor
                scales. Each of these scales contain seven notes
                that sound good together in generally any
                combination. Having all instruments play notes
                from the same major scale is a good first step to
                creating a pleasing sound. The seven notes of a
                major or minor scale can be played across multiple
                octaves from low to high. If you know
                nothing about music theory and you are
                starting a song, I recommend choosing one major
                or minor scale and sticking with it for all of
                your instruments. It may be easier to stay in that
                same scale for the entire duration of the song. If
                you decide on a key change within the song, it is
                usually easier to switch to a key which has a
                one-note difference from the current scale.<br/><br/>
                If you are familiar with the song
                “do-re-mi-fa-so-la-ti-do” each of these seven
                unique words represents a note of a major or minor
                scale. The first note “do” starts the octave. The
                last note “do” is actually a repeat of the first note
                but the pitch is in the start of the next higher octave. On a piano, or in Ableton’s piano roll, the seven-note pattern is repeated every octave.

                <br/><br/>
                <h3>Major scale notes on the piano reference.</h3>
                <img src={majorScale} alt={"Notes of major scale" }/><br/><br/>

        <h3>Minor scale notes on the piano reference.</h3>
                <img src={minorScale} alt={"Notes of minor scale" }/><br/>

            </div>
        )
    }
}
export default PianoMajorMinorScales;
